import React from "react";
import { Navigate } from "react-router-dom";
import { normalizeUser } from "../utils/user";
import { normalizeRole } from "../utils/roles";

export default function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");
  let user = null;

  try {
    user = userStr ? normalizeUser(JSON.parse(userStr)) : null;
  } catch (error) {
    console.error("Error parsing user:", error);
  }

  const role = normalizeRole(user?.role);

  if (!token || !user || !role) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
